import { Truck, CreditCard, Radio } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SystemPlansContent } from '@/components/admin/SystemPlansContent';
import { AdminProductsContent } from '@/components/admin/AdminProductsContent';

const PlansPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Truck className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-3xl font-bold">Planos FleetONE</h1>
          <p className="text-muted-foreground">
            Gerencie os planos de assinatura e equipamentos do FleetONE
          </p>
        </div>
      </div>

      <Tabs defaultValue="plans" className="space-y-4">
        <TabsList>
          <TabsTrigger value="plans" className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            Planos
          </TabsTrigger>
          <TabsTrigger value="equipment" className="flex items-center gap-2">
            <Radio className="h-4 w-4" />
            Equipamentos
          </TabsTrigger>
        </TabsList>

        <TabsContent value="plans">
          <SystemPlansContent 
            systemCode="fleet" 
            systemName="FleetONE" 
          />
        </TabsContent>

        <TabsContent value="equipment">
          <AdminProductsContent productType="gps_device" />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PlansPage;
